import React, { useState, useEffect, useRef } from "react";
import Layout from "../Layout/Layout.js";
import { APIUrl } from "../../Helper/APIUrl.js";
import { useSnackbar } from "notistack";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";

function Area() {
  const Token = JSON.parse(localStorage.getItem("tcn"));
  const { enqueueSnackbar } = useSnackbar();

  const [search, setsearch] = useState("");
  const [areaList, setareaList] = useState([]);
  const [filterareaList, setfilterareaList] = useState([]);
  const [cityList, setcityList] = useState([]);

  const AreaInputRef = useRef(null);

  const [AreaId, setAreaId] = useState("");
  const [AreaName, setAreaName] = useState("");
  const [CityId, setCityId] = useState(0);
  const [IsActive] = useState(true);
  const [CreatedBy] = useState(1);
  const [ModifiedBy] = useState(1);

  const [edit, setEdit] = useState(false);
  const [returnId, setreturnId] = useState(0);

  const AreaURL = APIUrl.Area;
  const CityURL = APIUrl.Cities;

  function doEmptyStates() {
    setAreaId("");
    setAreaName("");
    setCityId(0);
    setEdit(false);
    setreturnId(0);
  }

  const parseJSON = async (response) => {
    try {
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    } catch (err) {
      console.warn("Failed to parse JSON response", err);
      return null;
    }
  };

  const getAllCities = async () => {
    try {
      const response = await fetch(CityURL + "GetAllCity", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(),
      });

      const result = await parseJSON(response);
      const records = Array.isArray(result?.data)
        ? result.data.filter((x) => x.IsActive === true)
        : [];
      setcityList(records);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllArea = async () => {
    try {
      const response = await fetch(AreaURL + "GetAllArea", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(),
      });

      const result = await parseJSON(response);
      const records = Array.isArray(result?.data) ? result.data : [];
      setareaList(records);
      setfilterareaList(records);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCities();
    getAllArea();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const insertArea = async () => {
    try {
      debugger;
      if (AreaName.trim().length >= 2 && Number(CityId) > 0) {
        const data = {
          AreaName,
          CityId: Number(CityId),
          IsActive,
          CreatedBy,
          ModifyBy: ModifiedBy,
        };
        const response = await fetch(AreaURL + "InsertArea", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify(data),
        });

        const result = await parseJSON(response);
        if (result && result.returnID !== undefined) {
          setreturnId(result.returnID);
          enqueueSnackbar("Successfully Added", { variant: "success" });
          getAllArea();
          doEmptyStates();
        } else {
          enqueueSnackbar("Add failed: empty response", { variant: "error" });
        }
      } else {
        enqueueSnackbar("Fill all required fields to submit", {
          variant: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const editArea = async (Id) => {
    try {
      const items = areaList.filter((x) => x.AreaId === Id);

      items.forEach((item) => {
        setAreaId(item.AreaId);
        setAreaName(item.AreaName || "");
        setCityId(item.CityId || 0);
        setreturnId(item.AreaId);
      });

      setEdit(true);
      AreaInputRef.current.focus();
    } catch (error) {
      console.log(error);
    }
  };

  const updateArea = async (Id) => {
    try {
      if (AreaName.trim().length >= 2 && Number(CityId) > 0) {
        const data = {
          AreaId,
          AreaName,
          CityId: Number(CityId),
          ModifyBy: ModifiedBy,
        };

        const response = await fetch(AreaURL + "UpdateArea/" + Id, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify(data),
        });

        const result = await parseJSON(response);
        if (result && result.returnID !== undefined) {
          setreturnId(result.returnID);
          getAllArea();
          doEmptyStates();
          enqueueSnackbar("Successfully Updated", { variant: "success" });
        } else {
          enqueueSnackbar("Update failed: empty response", {
            variant: "error",
          });
        }
      } else {
        enqueueSnackbar("Fill all required fields to update", {
          variant: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const activateDeactivateArea = async (Id, Value) => {
    try {
      const data = { Value };
      const response = await fetch(AreaURL + "ActivateDeactivateArea/" + Id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(data),
      });

      const result = await parseJSON(response);
      if (result && result.returnID !== undefined) {
        setreturnId(result.returnID);
        getAllArea();
        doEmptyStates();

        Value === "activate"
          ? enqueueSnackbar("Successfully Activated", { variant: "success" })
          : enqueueSnackbar("Successfully Deactivated", { variant: "warning" });
      } else {
        enqueueSnackbar("Status change failed: empty response", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const result = areaList.filter((x) => {
      const cityName = (x.CityName || x.City || "") + "";
      const areaName = x.AreaName || "";
      return `${areaName} ${cityName}`
        .toLowerCase()
        .match(search.toLowerCase());
    });

    setfilterareaList(result);
  }, [search, areaList]);

  const coloumn = [
    {
      name: <strong>SNo.</strong>,
      selector: (row, index) => index + 1,
    },
    {
      name: <strong>City</strong>,
      selector: (row) => row.CityName || row.City,
      sortable: true,
      reorder: true,
    },
    {
      name: <strong>Area</strong>,
      selector: (row) => row.AreaName,
      sortable: true,
      reorder: true,
    },
    {
      name: <strong>Activated/Deactivated</strong>,
      selector: (row) =>
        row.IsActive ? (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
            Activated
          </label>
        ) : (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
            Deactivated
          </label>
        ),
    },
    {
      name: <strong>Action</strong>,
      cell: (row) => (
        <div>
          {!row.IsActive ? (
            <Button
              onClick={() => activateDeactivateArea(row.AreaId, "activate")}
              data-tip="Click to Activate Area"
              className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"
            >
              <i className="fa fa-toggle-off" aria-hidden="true"></i>
            </Button>
          ) : (
            <Button
              onClick={() => activateDeactivateArea(row.AreaId, "deactivate")}
              data-tip="Click to Deactivate Area"
              className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"
            >
              <i className="fa fa-toggle-on" aria-hidden="true"></i>
            </Button>
          )}
          <Button
            onClick={() => editArea(row.AreaId)}
            data-tip="Click to Edit Details"
            className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Layout>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">
                Add New Area
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
                <div>
                  <label
                    htmlFor="cityId"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    City
                  </label>
                  <select
                    id="cityId"
                    name="cityId"
                    value={CityId}
                    onChange={(e) => setCityId(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  >
                    <option value={0}>Select City</option>
                    {cityList
                      .filter((x) => x.IsActive !== false)
                      .map((item) => (
                        <option key={item.CityId} value={item.CityId}>
                          {item.CityName || item.City}
                        </option>
                      ))}
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="areaName"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Area Name
                  </label>
                  <input
                    type="text"
                    id="areaName"
                    name="areaName"
                    value={AreaName}
                    ref={AreaInputRef}
                    onChange={(e) => {
                      setAreaName(e.target.value);
                    }}
                    placeholder="Enter Area Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  />
                </div>

                <div className="md:col-span-3"></div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-4">
                {edit === false ? (
                  <Button
                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                    onClick={() => insertArea()}
                  >
                    <span>Add</span>
                  </Button>
                ) : (
                  <Button
                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                    onClick={() => updateArea(returnId)}
                  >
                    <span>Update</span>
                  </Button>
                )}

                <button
                  type="button"
                  onClick={() => doEmptyStates()}
                  className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="overflow-x-auto">
                <DataTable
                  title="Manage Area"
                  columns={coloumn}
                  data={filterareaList}
                  pagination
                  fixedHeader
                  fixedHeaderScrollHeight="550px"
                  selectableRows
                  selectableRowsHighlight
                  highlightOnHover
                  subHeader
                  subHeaderAlign="right"
                  subHeaderComponent={
                    <input
                      type="text"
                      placeholder="search city/area"
                      className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      value={search}
                      onChange={(e) => setsearch(e.target.value)}
                    />
                  }
                />
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </div>
  );
}

export default Area;
